import Me from "./images/general/me.webp";
import Wmcdacktpa from "./images/portfolio/wmcdacktpa.webp";
import Ttf from "./images/portfolio/ttf.webp";
import Rexit from "./images/portfolio/rexit.webp";
import ClassyEssayWriter from "./images/portfolio/classyessaywriter.webp";
import CustomWrittenPapers from "./images/portfolio/customwrittenpapers.webp";
import EssayWritingServices from "./images/portfolio/essaywritingservices.webp";
import TakeMyExam from "./images/portfolio/takemyexam.webp";
import Exoqual from "./images/portfolio/exoqual.webp";
import Dca from "./images/portfolio/dca.webp";
import AngelsAndDemons from "./images/portfolio/angels-and-demons.webp";
import BatGirl from "./images/portfolio/bat-girl.webp";
import Iggy from "./images/portfolio/iggy.webp";
import Zappyeels from "./images/portfolio/zappyeels.webp";
import Robotto from "./images/portfolio/robotto.webp";

export const images = {
    Me,
    Exoqual,
    Robotto,
    BatGirl,
    AngelsAndDemons,
    Dca,
    Zappyeels,
    Iggy,
    Wmcdacktpa,
    Ttf,
    ClassyEssayWriter,
    CustomWrittenPapers,
    EssayWritingServices,
    TakeMyExam,
    Rexit,
}